import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ArrowDown = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.26 9.266a.88.88 0 0 1 1.26 0L12 12.809l3.48-3.543a.88.88 0 0 1 1.26 0 .92.92 0 0 1 0 1.283l-4.11 4.185a.88.88 0 0 1-1.26 0L7.26 10.55a.92.92 0 0 1 0-1.283Z"
      fill={color}
    />
  </Svg>
)

export default ArrowDown
